import styled from '@emotion/styled';
import { colors } from 'Constants/Colors';
import { palette } from '../../../Dashboard.styled';

export const Wrap = styled.div`
  flex: 1;
  min-width: 0;
`;

export const Title = styled.h1`
  margin: 10px 0 8px;
  font-size: 30px;
  font-weight: 800;
  color: ${palette.ink};
`;

export const Meta = styled.div`
  font-size: 14px;
  color: ${palette.muted};
`;

export const GreenButton = styled.button`
  margin-top: 16px;
  padding: 12px 22px;
  border: none;
  border-radius: 999px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  color: ${colors.WHITE};
  background: ${palette.green};
  cursor: pointer;
`;
